import React from 'react';
function Hero() {
    return ( 
    <div className='container border-bottom mb-5'> 
        <div className='row text-center mt-5 mb-5 p-5'>
                <h1 className='mb-4 fs-3'>Zerodha Products</h1>
                <h3 className='fs-4 ' style={{fontWeight:"400"}}>Sleek, modern, and intuitive trading platforms</h3>
                <p className='mt-4'>Check out our <a href='' style={{textDecoration:"none"}}>investment offerings<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a></p>

        </div>
    </div>
);
}

export default Hero;